module.exports = __webpack_public_path__ + "media/alaska.ff11b58b.mp4";